import React, { useMemo } from "react";
import { useWeather } from "../contextprovider/weather";
import "../App.css";

const Layout = ({ children }) => {
  const myweather = useWeather();
  
  // 1. Dynamic Background Logic
  let weatherClass = "default-bg";
  if (myweather?.data?.current) {
    const condition = myweather.data.current.condition.text.toLowerCase();
    if (condition.includes("sun") || condition.includes("clear")) weatherClass = "sunny-bg";
    else if (condition.includes("rain") || condition.includes("drizzle")) weatherClass = "rainy-bg";
    else if (condition.includes("cloud") || condition.includes("overcast") || condition.includes("mist")) weatherClass = "cloudy-bg";
    else if (condition.includes("snow")) weatherClass = "snowy-bg";
  }

  // 2. Random Background Text Logic
  // This useMemo ensures the text doesn't change on every keystroke, only on reload/mount
  const randomText = useMemo(() => {
    const texts = [
      "Chase the Sun",
      "Weather the Storm",
      "Keep Looking Up",
      "Sky Above, Earth Below",
      "Nature's Mood",
      "Forecast: Amazing",
      "Hello World"
    ];
    return texts[Math.floor(Math.random() * texts.length)];
  }, []);

  return (
    <div className={`app-container ${weatherClass}`}>
      {/* 3. The Big Background Text */}
      <h1 className="background-watermark">{randomText}</h1>

      {/* The Glass Card */}
      <div className="glass-wrapper">
        <h2 className="app-title">Weather Forecast</h2>
        {children}
      </div>
    </div>
  );
};

export default Layout;